import React, { useContext } from 'react';
import { Box, Text, Button } from "@chakra-ui/react";
import { Link } from 'react-router-dom';
import { CartContext } from '../../Context/CartContext';
import { FaShoppingCart, FaArrowRight } from 'react-icons/fa';

export function AddToCartPopUp() {
  const { cartItemsCounter } = useContext(CartContext);

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      width="100%"
      zIndex="1000"
      bg="white"
      boxShadow="0 -8px 40px rgba(0,74,51,.18)"
      animation="slideUp 0.25s cubic-bezier(0.23,1,0.32,1)"
      sx={{
        "@keyframes slideUp": {
          from: { transform: "translateY(100%)", opacity: 0 },
          to:   { transform: "translateY(0)",    opacity: 1 },
        },
      }}
    >
      {/* Green header strip */}
      <Box
        bg="linear-gradient(135deg, #004a33 0%, #006646 100%)"
        px={{ base: "16px", md: "24px" }}
        py="12px"
        display="flex"
        alignItems="center"
        gap="12px"
      >
        <Box
          w="36px"
          h="36px"
          borderRadius="50%"
          bg="rgba(255,255,255,.12)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
        >
          <FaShoppingCart color="#fc8f04" size={15} />
        </Box>

        <Box flex={1}>
          <Text color="white" fontWeight="900" fontSize="15px" lineHeight="1.1">
            Produto adicionado ao carrinho!
          </Text>
          <Text color="rgba(255,255,255,.55)" fontSize="11px" fontWeight="600">
            {cartItemsCounter} {cartItemsCounter === 1 ? "item" : "itens"} no carrinho
          </Text>
        </Box>

        {/* Pill counter */}
        <Box
          bg="#fc8f04"
          borderRadius="99px"
          w="28px"
          h="28px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
        >
          <Text color="#004a33" fontWeight="900" fontSize="13px" lineHeight="1">
            {cartItemsCounter}
          </Text>
        </Box>
      </Box>

      {/* Action buttons */}
      <Box
        px={{ base: "16px", md: "24px" }}
        py="14px"
        display="flex"
        gap="10px"
        maxW="560px"
        mx="auto"
      >
        <Link
          to={`/produtos?filter=${encodeURIComponent(JSON.stringify(["Bebidas"]))}`}
          style={{ flex: 1, textDecoration: "none" }}
        >
          <Button
            w="100%"
            h="48px"
            borderRadius="14px"
            variant="outline"
            borderColor="rgba(0,74,51,.2)"
            color="#004a33"
            fontWeight="700"
            fontSize="13px"
            _hover={{ bg: "rgba(0,74,51,.05)", borderColor: "#004a33" }}
          >
            + Continuar comprando
          </Button>
        </Link>

        <Link to="/carrinho" style={{ flex: 1, textDecoration: "none" }}>
          <Button
            w="100%"
            h="48px"
            borderRadius="14px"
            bg="#004a33"
            color="#fc8f04"
            fontWeight="900"
            fontSize="13px"
            rightIcon={<FaArrowRight size={11} />}
            _hover={{ opacity: 0.9 }}
          >
            Finalizar pedido
          </Button>
        </Link>
      </Box>
    </Box>
  );
}
